import {firebaseConfig} from "./firebase";
import {initializeApp} from "firebase/app";

export const app = initializeApp(firebaseConfig);